import React,{Component} from 'react';  
// import TablePagination from '../Pagination';
var mystyle;
// var count = 0;
var tableBody = [];
// var currentTableBody = [];
var color = 'black';
//modified table header, value is coming from this.props.mHeaders
var mHeaders=[];

function isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

class SendoutTable extends Component{
    constructor(props){
        super(props);
        this.state = {
            tbody:''
        }
        mystyle = this.props.myStyle ? this.props.myStyle:{}; 
        mHeaders = this.props.mHeaders;
        this.makeTableBody = this.makeTableBody.bind(this);
        this.appendIntoTableBody = this.appendIntoTableBody.bind(this);
        // this.displayDataFromChild = this.displayDataFromChild.bind(this);
        // this.handlePageChange = this.handlePageChange.bind(this);
    }

    componentWillReceiveProps(nextProp){
        // console.log('resetTable: '+ nextProp.resetTable);
        if(typeof this.props.resetTable === 'boolean'){
            if(this.props.resetTable !== nextProp.resetTable){
                console.log('reset');
                tableBody = [];
            }
        }
    }
   

    updateTableBody(){
        console.log('inside update table body ',this.props.body)
        tableBody = [];
        var myTab = document.getElementById('myTable');

        for(let i = 0; i< this.props.body.length; i++){
            console.log('body length is ',this.props.body.length)
            if(this.props.body[i].ownerBranch){
                tableBody.push(
                    <tr key = {this.props.body[i].number}>
                        <td style = {{color:color}}>
                            {this.props.body[i].number}
                        </td>
                        <td style = {{color:color}}>
                            {this.props.body[i].ownerBranch}
                        </td>
                        <td style = {{color:color}}>
                            {this.props.body[i].message}
                        </td>
                    </tr>
                )    
            }else{

                tableBody.push(
                    <tr key = {this.props.body[i].number}>
                        <td style = {{color:color}}>
                            {this.props.body[i].number}
                        </td>
                        <td style = {{color:color}}>
                            {this.props.body[i].message}
                        </td>
                    </tr>
                )
                
            }        

        }


        // LOOP THROUGH EACH ROW OF THE TABLE AFTER HEADER.
        
    }
    appendIntoTableBody(){
       console.log('inside append table body');
       
       if(this.props.colorToDisplay && this.props.colorToDisplay.length > 0){
           console.log(this.props.colorToDisplay);
           color = this.props.colorToDisplay;
       }
        tableBody.push(
            <tr key = {this.props.body.number}>
            {
                mHeaders.map(value =>{
                return (
                    //modified headers are value
                    <td style = {{color:color}} key = {value}>  
                    {
                        Object.keys(this.props.body).map((val)=>{
                            if(val === value)
                                return this.props.body[val];
                        })
                    }
                    </td>)
                })
            }
                
            </tr>
        )
        console.log(tableBody.length);
        if(this.props.displayCount){
            this.props.displayCount.value = tableBody.length;
        }
        // if(this.props.fetchTableBody && this.props.shouldUpdate){
        //     console.log('sending table data to parent');
        //     this.props.fetchTableBody(tableBody);
        // }
    }

    makeTableBody(){
        
        var size = tableBody.length;
        var b = false;
        if(size > 0){
            for(let i =0 ; i< size; i++){
                if(tableBody[i] && tableBody[i].key !== this.props.body.number){
                    b=true;
                }
                else{
                    b=false;
                    break;
                }
            }
        }
        else{
            b = true;
        }
        if(b){
            this.appendIntoTableBody();
        }
            
        
    }
    
    render()
    {

        var isBodyPropArray = Array.isArray(this.props.body);
        if(!isBodyPropArray && isEmpty(this.props.body)){
            tableBody = [];
        }
        else if(isBodyPropArray && this.props.body.length > 0){
            this.updateTableBody();
        }
        else{
            this.makeTableBody();
        }

        return(
            <React.Fragment>
            <table className = "table table-hover table-bordered" id = "myTable" style = {mystyle}>
                <thead>
                    <tr>
                        {this.props.headers.map((value)=>{
                            return <th key = {value}>{value}</th>
                        })}
                    </tr>
                </thead>
                <tbody>
                    
                    {(tableBody.length > 0)?
                        tableBody.map(value =>{
                        if(value){
                            return value;
                        }
                        else{
                            return null;
                        }
                    }):null}
                </tbody>
                
            </table>
            </React.Fragment>
        )
    }
}

export default SendoutTable;


// WEBPACK FOOTER //
// ./src/Components/Sending-Out/sendOutTable.js